// wrap everything in an anonymous function to avoid any conflicts with other js in the page
import Promise from 'promise-polyfill';

// To add to window
if (!window.Promise) {
  window.Promise = Promise;
}

(function (window, undefined) {
  const { NODE_ENV } = process.env;
  const SENTRY_KEY = 'https://ea5ec4ef978e46f28c460aa12e12a2bd@sentry.io/223105';
  let initOpenchair;
  // init raven
  if (NODE_ENV === 'production') {
    const Raven = require('raven-js');
    Raven
      .config(SENTRY_KEY, {
        environment: NODE_ENV,
      })
      .install();
    // it's a backup for any uncaught errors in promises - only works in latest chrome (not localhost) and safari
    window.addEventListener('unhandledrejection', (evt) => {
      Raven.captureException(evt.reason);
    });
    initOpenchair = function () {
      Raven.context(() => {
        const ctrl = require('./widgetController.js').widgetCtrl;
        ctrl.init();
      });
    };
  } else {
    initOpenchair = function () {
      const ctrl = require('./widgetController.js').widgetCtrl;
      ctrl.init();
    };
  }

  // get polyfills
  const polyfillScript = document.createElement('script');
  polyfillScript.src = 'https://cdn.polyfill.io/v2/polyfill.min.js?features=default,fetch';
  polyfillScript.async = true;
  polyfillScript.onload = initOpenchair;
  const entry = document.getElementsByTagName('script')[0];
  entry.parentNode.insertBefore(
    polyfillScript,
    entry,
  );

  const gaScript = document.createElement('script');
  gaScript.innerHTML = "window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;ga('create', 'UA-108005724-1', 'auto', 'openchair');ga('require', 'GTM-TJF2DWV');ga('openchair.send', 'pageview', location.hash);";
  const gaScriptLoader = document.createElement('script');
  gaScriptLoader.src = 'https://www.google-analytics.com/analytics.js';
  gaScriptLoader.async = true;

  entry.parentNode.appendChild(gaScript);
  entry.parentNode.appendChild(gaScriptLoader);
}(window));



// WEBPACK FOOTER //
// ./src/index.js